export const INITIAL_TABLE_HEADERS = {
    "ventas_netas": {
        label: 'Ventas Netas',
        isMoney: true,
        keysSum: ['ventas_netas'],
        itemsDict: {},
        items: []
    },
    "costos_productos": {
        label: 'Costos Productos',
        isMoney: true,
        keysSum: ['costos_productos'],
        itemsDict: {},
        items: []
    },
    "margen_producto": {
        label: 'Margen Producto %',
        isMoney: false,
        theme: 'theme_row_blue',
        keysSum: ['margen_producto'],
        itemsDict: {},
        items: []
    },
    "costos_variables": {
        label: 'Costos Variables',
        isMoney: true,
        keysSum: ['costos_variables'],
        itemsDict: {},
        items: []
    },
    "costos_directos": {
        label: 'Costos Directos',
        isMoney: true,
        keysSum: ['costos_directos'],
        itemsDict: {},
        items: []
    },
    "margen_bruto": {
        label: 'Margen Bruto %',
        isMoney: false,
        theme: 'theme_row_blue',
        keysSum: ['ventas_netas'],
        keysSubtract: ['costos_directos'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "costos_fijos": {
        label: 'Costos Fijos',
        isMoney: true,
        keysSum: ['costos_fijos'],
        itemsDict: {},
        items: []
    },
    "margen_contribucion": {
        label: 'Margen Contribución',
        isMoney: false,
        theme: 'theme_row_azure',
        keysSum: ['margen_contribucion'],
        itemsDict: {},
        items: []
    },
    "gastos_totales": {
        label: 'Gastos Totales',
        isMoney: true,
        hasChilds: true,
        keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        itemsDict: {},
        items: []
    },
    "gastos_administracion": {
        label: 'Gastos Administración',
        isMoney: true,
        isShowed: false,
        theme: 'nobreak theme_row_detail_bills ',
        keysSum: ['gastos_administracion'],
        itemsDict: {},
        items: []
    },
    "gastos_comerciales": {
        label: 'Gastos Comerciales',
        isMoney: true,
        isShowed: false,
        theme: 'theme_row_detail_bills nobreak',
        keysSum: ['gastos_comerciales'],
        itemsDict: {},
        items: []
    },
    "gastos_i+d": {
        label: 'Gastos I+D',
        isMoney: true,
        isShowed: false,
        theme: 'theme_row_detail_bills',
        keysSum: ['gastos_i+d'],
        itemsDict: {},
        items: []
    },
    "gastos/ventas_%": {
        label: 'Gastos/Ventas %',
        isMoney: false,
        theme: 'theme_row_yellow',
        keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "EBITDA": {
        label: 'EBITDA',
        isMoney: true,
        keysSum: ['ventas_netas'],
        keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        itemsDict: {},
        items: []
    },
    "margen_EBITDA_%": {
        label: 'Margen EBITDA %',
        isMoney: false,
        theme: 'theme_row_purple',
        keysSum: ['ventas_netas'],
        keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
    "no_operacional": {
        label: 'No Operacional',
        isMoney: true,
        keysSum: ['ingresos_no_operacional'],
        keysSubtract: ['gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "ingresos_no_operacional": {
        label: 'Ingresos No Operacional',
        isMoney: true,
        keysSum: ['ingresos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "gastos_no_operacional": {
        label: 'Gastos No Operacional',
        isMoney: true,
        keysSum: ['gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "utilidad_antes_de_impuestos": {
        label: 'Utilidad Antes de Impuestos',
        isMoney: true,
        keysSum: ['ventas_netas', 'ingresos_no_operacional'],
        keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d', 'gastos_no_operacional'],
        itemsDict: {},
        items: []
    },
    "margen_neto_%": {
        label: 'Margen Neto %',
        isMoney: false,
        theme: 'theme_row_orange',
        keysSum: ['ventas_netas', 'ingresos_no_operacional'],
        keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d', 'gastos_no_operacional'],
        keyDivide: 'ventas_netas',
        itemsDict: {},
        items: []
    },
};

export const CALCULATED_KEYS = [
    'margen_bruto', 'gastos_totales', 'gastos/ventas_%',
    'EBITDA', 'margen_EBITDA_%', 'no_operacional', 'utilidad_antes_de_impuestos',
    'margen_neto_%'
];

export const PERIOD_TYPES = [
    { value: "lastYear", label: "Último año" },
    { value: "last24months", label: "Últimos 24 Meses" },
    { value: "actualYear", label: "Año Actual" },
    { value: "previousYear", label: "Año Anterior" },
];

export const EXPENSE_COUNTERPART_TYPES = [
    { id: 'proveedores', label: 'Proveedores' },
    { id: 'remuneraciones', label: 'Remuneraciones' },
    { id: 'honorarios', label: 'Honorarios' },
    { id: 'internacional', label: 'Internacional' },
    { id: 'recibo', label: 'Recibo' },
    { id: 'finiquito', label: 'Finiquito' },
];

export const EXPENSE_CARD_PROGRESS_COLORS = [
    'var(--progress-bar-1)',
    'var(--progress-bar-2)',
    'var(--progress-bar-3)',
];

export const REPORT_DETAILS_CONFIG = [
    {
        label: 'Crecimiento',
        value: '% MoM',
        theme: 'themePercentGreen',
        key: 'ventas_netas'
    }, {
        label: 'Margen Bruto',
        value: '%',
        theme: 'themePercentBlue',
        key: 'margen_bruto'
    }, {
        label: 'Eficiencia',
        value: '%',
        theme: 'themePercentOrange',
        key: 'gastos/ventas_%'
    }, {
        label: 'Margen EBITDA',
        value: '%',
        theme: 'themePercentPurple',
        key: 'margen_EBITDA_%'
    }
];
